import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, style, state, animate, transition, keyframes, query, group} from '@angular/animations';
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";

declare var $ :any;

@Component({
  selector: 'app-case-practice-p-and-o-event',
  animations: [
    trigger(
    'wrapAnimation', [
      transition(':enter', [
        style({opacity: 0}),
        // query('#questionCard', style({transform: 'rotate(90deg) scale(0, 0)', transformOrigin: '100% 0%'})),
        // query('.questionTitle', style({transform: 'rotate(90deg) scale(0, 0)', transformOrigin: '100% 0%'})),
        // query('.optionItem', style({transform: 'scale(0)', transformOrigin: '50% 50%'}), { optional: true }),
        // query('.questionBtn', style({transform: 'scale(0)', transformOrigin: '50% 50%'})),
        // query('#nextStep', style({transform: 'translate(-300%)'})),
        animate('200ms', style({opacity: 1})),
        // group([
        //   query('#questionCard', animate('200ms', keyframes([
        //       style({opacity: 0.1, transform: 'rotate(90deg) scale(0.1, 0.1)', transformOrigin: '100% 0%'}),
        //       style({opacity: 0.3, transform: 'rotate(70deg) scale(0.3, 0.3)', transformOrigin: '100% 0%'}),
        //       style({opacity: 0.5, transform: 'rotate(50deg) scale(0.5, 0.5)', transformOrigin: '100% 0%'}),
        //       style({opacity: 0.7, transform: 'rotate(30deg) scale(0.7, 0.7)', transformOrigin: '100% 0%'}),
        //       style({opacity: 0.9, transform: 'rotate(10deg) scale(0.9, 0.9)', transformOrigin: '100% 0%'}),
        //       style({opacity: 1, transform: 'rotate(0) scale(1, 1)', transformOrigin: '100% 0%'}),
        //     ])
        //   )),
        //   query('.questionTitle', animate('200ms', keyframes([
        //       style({opacity: 0.1, transform: 'rotate(90deg) scale(0.1, 0.1)', transformOrigin: '100% 0%'}),
        //       style({opacity: 0.3, transform: 'rotate(70deg) scale(0.3, 0.3)', transformOrigin: '100% 0%'}),
        //       style({opacity: 0.5, transform: 'rotate(50deg) scale(0.5, 0.5)', transformOrigin: '100% 0%'}),
        //       style({opacity: 0.7, transform: 'rotate(30deg) scale(0.7, 0.7)', transformOrigin: '100% 0%'}),
        //       style({opacity: 0.9, transform: 'rotate(10deg) scale(0.9, 0.9)', transformOrigin: '100% 0%'}),
        //       style({opacity: 1, transform: 'rotate(0) scale(1, 1)', transformOrigin: '100% 0%'}),
        //     ])
        //   ))
        // ]),
        // group([
        //   query('.optionItem', animate('400ms', keyframes([
        //       style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0.1, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0.3, transform: 'scale(0.3)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0.5, transform: 'scale(0.5)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0.7, transform: 'scale(0.7)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0.9, transform: 'scale(0.9)', transformOrigin: '50% 50%'}),
        //       style({opacity: 1, transform: 'scale(1)', transformOrigin: '50% 50%'}),
        //     ])
        //   ), { optional: true }),
        //   query('.questionBtn', animate('400ms', keyframes([
        //       style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0.1, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0.3, transform: 'scale(0.3)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0.5, transform: 'scale(0.5)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0.7, transform: 'scale(0.7)', transformOrigin: '50% 50%'}),
        //       style({opacity: 0.9, transform: 'scale(0.9)', transformOrigin: '50% 50%'}),
        //       style({opacity: 1, transform: 'scale(1)', transformOrigin: '50% 50%'}),
        //     ])
        //   )),
        ])
    ]),
    trigger('teacherAnimation', [
      state('hideTeacher', style({transform: 'scale(0, 0)', opacity: 0})),
      state('showTeacher', style({transform: 'scale(1, 1)', opacity: 1})),
      transition('hideTeacher => showTeacher', animate('200ms', keyframes([
        style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ]))),
      transition('showTeacher => hideTeacher', animate('200ms', style({opacity: 0}))),
    ]),
    trigger('instructionAnimation', [
      state('hideInstruction', style({transform: 'translate(-300%, -50%)', opacity: 0})),
      state('showInstruction', style({transform: 'translate(0%, -50%)', opacity: 1})),
      transition('hideInstruction => showInstruction', animate('500ms', keyframes([
        style({transform: 'translate(-150%, -50%)', opacity: 0.2}),
        style({transform: 'translate(-90%, -50%)', opacity: 0.5}),
        style({transform: 'translate(-60%, -50%)', opacity: 1}),
        style({transform: 'translate(-40%, -50%)', opacity: 1}),
        style({transform: 'translate(-20%, -50%)', opacity: 1}),
        style({transform: 'translate(0%, -50%)', opacity: 1})
      ]))),
      transition('showInstruction => hideInstruction', animate('500ms', keyframes([
        style({opacity: 1}),
        style({opacity: 0.8}),
        style({opacity: 0.6}),
        style({opacity: 0.4}),
        style({opacity: 0.2}),
        style({opacity: 0})
      ]))),
    ]),
    trigger('infoTableAnimation', [
      state('hideInfoTable', style({transform: 'scale(0, 0)', opacity: 0})),
      state('showInfoTable', style({transform: 'scale(1, 1)', opacity: 1})),
      transition('hideInfoTable => showInfoTable', animate('200ms', keyframes([
        style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ]))),
      transition('showInfoTable => hideInfoTable', animate('200ms', keyframes([
        style({opacity: 1}),
        style({opacity: 0.8}),
        style({opacity: 0.6}),
        style({opacity: 0.4}),
        style({opacity: 0.2}),
        style({opacity: 0})
      ]))),
    ]),
    trigger('decisionAnimation', [
      state('hideDecision', style({transform: 'scale(0, 0)', opacity: 0})),
      state('showDecision', style({transform: 'scale(1, 1)', opacity: 1})),
      transition('hideDecision => showDecision', animate('200ms', keyframes([
        style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ]))),
      transition('showDecision => hideDecision', animate('200ms', keyframes([
        style({opacity: 1}),
        style({opacity: 0.8}),
        style({opacity: 0.6}),
        style({opacity: 0.4}),
        style({opacity: 0.2}),
        style({opacity: 0})
      ]))),
    ]),
    trigger('dialogue1Animation', [
      state('hideDiag1', style({transform: 'scale(0, 0)', opacity: 0})),
      state('showDiag1', style({transform: 'scale(1, 1)', opacity: 1})),
      transition('hideDiag1 => showDiag1', animate('200ms', keyframes([
        style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ]))),
      transition('showDiag1 => hideDiag1', animate('200ms', keyframes([
        style({opacity: 1, transform: 'scale(0.9, 0.9)'}),
        style({opacity: 0.8,  transform: 'scale(0.8, 0.8)'}),
        style({opacity: 0.6,  transform: 'scale(0.6, 0.6)'}),
        style({opacity: 0.4,  transform: 'scale(0.4, 0.4)'}),
        style({opacity: 0.2,  transform: 'scale(0.2, 0.2)'}),
        style({opacity: 0,  transform: 'scale(0.1, 0.1)'})
      ]))),
    ]),
    trigger('dialogue2Animation', [
      state('hideDiag2', style({transform: 'scale(0, 0)', opacity: 0})),
      state('showDiag2', style({transform: 'scale(1, 1)', opacity: 1})),
      transition('hideDiag2 => showDiag2', animate('200ms', keyframes([
        style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ]))),
      transition('showDiag2 => hideDiag2', animate('200ms', keyframes([
        style({opacity: 1, transform: 'scale(0.9, 0.9)'}),
        style({opacity: 0.8,  transform: 'scale(0.8, 0.8)'}),
        style({opacity: 0.6,  transform: 'scale(0.6, 0.6)'}),
        style({opacity: 0.4,  transform: 'scale(0.4, 0.4)'}),
        style({opacity: 0.2,  transform: 'scale(0.2, 0.2)'}),
        style({opacity: 0,  transform: 'scale(0.1, 0.1)'})
      ]))),
    ]),
    trigger('wlnPhoneAnimation', [
    state('hideWlnPhone', style({transform: 'translate(-300%)', opacity: 0})),
    state('showWlnPhone', style({transform: 'translate(0%)', opacity: 1})),
    transition('hideWlnPhone => showWlnPhone', animate('1s', keyframes([
      style({transform: 'translate(-150%)', opacity: 0.2}),
      style({transform: 'translate(-50%)', opacity: 0.5}),
      style({transform: 'translate(0%)', opacity: 1}),
      style({transform: 'translate(1px, 1px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(-1px, -2px) rotate(-1deg)', opacity: 1}),
      style({transform: 'translate(-3px, 0px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(3px, 2px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(1px, -1px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(-1px, 2px) rotate(-1deg)', opacity: 1}),
      style({transform: 'translate(-3px, 1px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(1px, 1px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(-1px, -2px) rotate(-1deg)', opacity: 1}),
      style({transform: 'translate(-3px, 0px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(3px, 2px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(1px, -1px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(-1px, 2px) rotate(-1deg)', opacity: 1}),
      style({transform: 'translate(-3px, 1px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(0%)', opacity: 1}),
      style({transform: 'translate(0%)', opacity: 1}),
      style({transform: 'translate(0%)', opacity: 1}),
      style({transform: 'translate(0%)', opacity: 1}),
      style({transform: 'translate(0%)', opacity: 1}),
      style({transform: 'translate(1px, 1px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(-1px, -2px) rotate(-1deg)', opacity: 1}),
      style({transform: 'translate(-3px, 0px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(3px, 2px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(1px, -1px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(-1px, 2px) rotate(-1deg)', opacity: 1}),
      style({transform: 'translate(-3px, 1px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(1px, 1px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(-1px, -2px) rotate(-1deg)', opacity: 1}),
      style({transform: 'translate(-3px, 0px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(3px, 2px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(1px, -1px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(-1px, 2px) rotate(-1deg)', opacity: 1}),
      style({transform: 'translate(-3px, 1px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(1px, -1px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(0, 0) rotate(0deg)', opacity: 1}),
    ]))),
    transition('showWlnPhone => hideWlnPhone', animate('200ms', keyframes([
      style({opacity: 1}),
      style({opacity: 0.8}),
      style({opacity: 0.6}),
      style({opacity: 0.4}),
      style({opacity: 0.2}),
      style({opacity: 0})
    ]))),
  ]),
  trigger('fkkPhoneAnimation', [
    state('hideFkkPhone', style({transform: 'translate(-300%)', opacity: 0})),
    state('showFkkPhone', style({transform: 'translate(0%)', opacity: 1})),
    transition('hideFkkPhone => showFkkPhone', animate('1s', keyframes([
      style({transform: 'translate(-150%)', opacity: 0.2}),
      style({transform: 'translate(-50%)', opacity: 0.5}),
      style({transform: 'translate(0%)', opacity: 1}),
      style({transform: 'translate(1px, 1px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(-1px, -2px) rotate(-1deg)', opacity: 1}),
      style({transform: 'translate(-3px, 0px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(3px, 2px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(1px, -1px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(-1px, 2px) rotate(-1deg)', opacity: 1}),
      style({transform: 'translate(-3px, 1px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(1px, 1px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(-1px, -2px) rotate(-1deg)', opacity: 1}),
      style({transform: 'translate(-3px, 0px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(3px, 2px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(1px, -1px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(-1px, 2px) rotate(-1deg)', opacity: 1}),
      style({transform: 'translate(-3px, 1px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(0%)', opacity: 1}),
      style({transform: 'translate(0%)', opacity: 1}),
      style({transform: 'translate(0%)', opacity: 1}),
      style({transform: 'translate(0%)', opacity: 1}),
      style({transform: 'translate(0%)', opacity: 1}),
      style({transform: 'translate(1px, 1px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(-1px, -2px) rotate(-1deg)', opacity: 1}),
      style({transform: 'translate(-3px, 0px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(3px, 2px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(1px, -1px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(-1px, 2px) rotate(-1deg)', opacity: 1}),
      style({transform: 'translate(-3px, 1px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(1px, 1px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(-1px, -2px) rotate(-1deg)', opacity: 1}),
      style({transform: 'translate(-3px, 0px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(3px, 2px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(1px, -1px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(-1px, 2px) rotate(-1deg)', opacity: 1}),
      style({transform: 'translate(-3px, 1px) rotate(0deg)', opacity: 1}),
      style({transform: 'translate(1px, -1px) rotate(1deg)', opacity: 1}),
      style({transform: 'translate(0, 0) rotate(0deg)', opacity: 1}),
    ]))),
    transition('showFkkPhone => hideFkkPhone', animate('200ms', keyframes([
      style({opacity: 1}),
      style({opacity: 0.8}),
      style({opacity: 0.6}),
      style({opacity: 0.4}),
      style({opacity: 0.2}),
      style({opacity: 0})
    ]))),
  ]),
  trigger('fkkContentAnimation', [
    state('hideFkkContent', style({transform: 'scale(0, 0)', opacity: 0})),
    state('showFkkContent', style({transform: 'scale(1, 1)', opacity: 1})),
    transition('hideFkkContent => showFkkContent', animate('200ms', keyframes([
      style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
      style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
      style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
      style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
      style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
      style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
      style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
      style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
      style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
      style({transform: 'scale(1, 1)', opacity: 1})
    ]))),
    transition('showFkkContent => hideFkkContent', animate('200ms', keyframes([
      style({opacity: 1}),
      style({opacity: 0.8}),
      style({opacity: 0.6}),
      style({opacity: 0.4}),
      style({opacity: 0.2}),
      style({opacity: 0})
    ]))),
  ]),
  trigger('taskTableAnimation', [
    state('hideTaskTable', style({transform: 'scale(0, 0)', opacity: 0})),
    state('showTaskTable', style({transform: 'scale(1, 1)', opacity: 1})),
    transition('hideTaskTable => showTaskTable', animate('500ms', keyframes([
      style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
      style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
      style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
      style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
      style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
      style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
      style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
      style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
      style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
      style({transform: 'scale(1, 1)', opacity: 1})
    ]))),
    transition('showTaskTable => hideTaskTable', animate('200ms', keyframes([
      style({opacity: 1}),
      style({opacity: 0.8}),
      style({opacity: 0.6}),
      style({opacity: 0.4}),
      style({opacity: 0.2}),
      style({opacity: 0})
    ]))),
  ]),
  trigger('urgentAnimation', [
    state('hideUrgent', style({transform: 'scale(1, 1) rotateY(90deg)', opacity: 0, zIndex: -1})),
    state('showUrgent', style({transform: 'scale(1, 1)', opacity: 1, zIndex: 9999})),
    transition('hideUrgent => showUrgent', animate('250ms', keyframes([
      style({zIndex: 9999}),
      style({transform: 'scale(1, 1) rotateY(90deg)', opacity: 1}),
      style({transform: 'scale(1, 1) rotateY(80deg)', opacity: 1}),
      style({transform: 'scale(1, 1) rotateY(75deg)', opacity: 1}),
      style({transform: 'scale(1, 1) rotateY(67deg)', opacity: 1}),
      style({transform: 'scale(1, 1) rotateY(60deg)', opacity: 1}),
      style({transform: 'scale(1, 1) rotateY(52deg)', opacity: 1}),
      style({transform: 'scale(1, 1) rotateY(45deg)', opacity: 1}),
      style({transform: 'scale(1, 1) rotateY(30deg)', opacity: 1}),
      style({transform: 'scale(1, 1) rotateY(0deg)', opacity: 1}),
      style({transform: 'scale(0.8, 0.8) rotateY(0deg)', opacity: 1}),
    ]))),
    transition('showUrgent => hideUrgent', animate('200ms', keyframes([
      style({opacity: 1}),
      style({opacity: 0.8}),
      style({opacity: 0.6}),
      style({opacity: 0.4}),
      style({opacity: 0.2}),
      style({opacity: 0})
    ]))),
  ]),
  trigger('urgent2Animation', [
  state('hideUrgent2', style({transform: 'scale(1, 1)', opacity: 0, zIndex: -1})),
  state('showUrgent2', style({transform: 'scale(1, 1)', opacity: 1, zIndex: 9999})),
  transition('hideUrgent2 => showUrgent2', animate('200ms', keyframes([
    style({zIndex: 9999}),
    style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
    style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
    style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
    style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
    style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
    style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
    style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
    style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
    style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
    style({transform: 'scale(1, 1)', opacity: 1})
  ]))),
  transition('showUrgent2 => hideUrgent2', animate('200ms', keyframes([
    style({opacity: 1}),
    style({opacity: 0.8}),
    style({opacity: 0.6}),
    style({opacity: 0.4}),
    style({opacity: 0.2}),
    style({opacity: 0})
  ]))),
]),
  trigger('questionCardAnimation', [
    state('hideQCard', style({transform: 'rotate(90deg) scale(0, 0)', transformOrigin: '100% 0%', opacity: 0})),
    state('showQCard', style({transform: 'rotate(0deg) scale(1, 1)', opacity: 1})),
    transition('hideQCard => showQCard', [
      query('.questionTitle', style({transform: 'rotate(90deg) scale(0, 0)', transformOrigin: '100% 0%'})),
      query('.optionItem', style({transform: 'scale(0)', transformOrigin: '50% 50%'}), { optional: true }),
      query('.sortOptionItem', style({transform: 'scale(0)', transformOrigin: '50% 50%'}), {optional: true}),
      query('.questionBtn', style({transform: 'scale(0)', transformOrigin: '50% 50%'}), { optional: true }),
      animate('200ms', keyframes([
          style({transform: 'scale(1, 1) rotate(90deg)', opacity: 1}),
          style({transform: 'scale(1, 1) rotate(75deg)', opacity: 1}),
          style({transform: 'scale(1, 1) rotate(60deg)', opacity: 1}),
          style({transform: 'scale(1, 1) rotate(45deg)', opacity: 1}),
          style({transform: 'scale(1, 1) rotate(30deg)', opacity: 1}),
          style({transform: 'scale(1, 1) rotate(0deg)', opacity: 1}),
      ])),
      // query('#nextStep', style({transform: 'translate(-300%)'})),
      query('.questionTitle', animate('200ms', keyframes([
          style({opacity: 0.1, transform: 'rotate(90deg) scale(0.1, 0.1)', transformOrigin: '100% 0%'}),
          style({opacity: 0.3, transform: 'rotate(70deg) scale(0.3, 0.3)', transformOrigin: '100% 0%'}),
          style({opacity: 0.5, transform: 'rotate(50deg) scale(0.5, 0.5)', transformOrigin: '100% 0%'}),
          style({opacity: 0.7, transform: 'rotate(30deg) scale(0.7, 0.7)', transformOrigin: '100% 0%'}),
          style({opacity: 0.9, transform: 'rotate(10deg) scale(0.9, 0.9)', transformOrigin: '100% 0%'}),
          style({opacity: 1, transform: 'rotate(0) scale(1, 1)', transformOrigin: '100% 0%'}),
        ])
      )),
      group([
        query('.optionItem', animate('500ms', keyframes([
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0.1, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0.3, transform: 'scale(0.3)', transformOrigin: '50% 50%'}),
            style({opacity: 0.5, transform: 'scale(0.5)', transformOrigin: '50% 50%'}),
            style({opacity: 0.7, transform: 'scale(0.7)', transformOrigin: '50% 50%'}),
            style({opacity: 0.9, transform: 'scale(0.9)', transformOrigin: '50% 50%'}),
            style({opacity: 1, transform: 'scale(1)', transformOrigin: '50% 50%'}),
          ])
        ), { optional: true }),
        query('.sortOptionItem', animate('500ms', keyframes([
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0.1, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0.3, transform: 'scale(0.3)', transformOrigin: '50% 50%'}),
            style({opacity: 0.5, transform: 'scale(0.5)', transformOrigin: '50% 50%'}),
            style({opacity: 0.7, transform: 'scale(0.7)', transformOrigin: '50% 50%'}),
            style({opacity: 0.9, transform: 'scale(0.9)', transformOrigin: '50% 50%'}),
            style({opacity: 1, transform: 'scale(1)', transformOrigin: '50% 50%'}),
          ])
        ), { optional: true }),
        query('.questionBtn', animate('500ms', keyframes([
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0.1, transform: 'scale(0.1)', transformOrigin: '50% 50%'}),
            style({opacity: 0.3, transform: 'scale(0.3)', transformOrigin: '50% 50%'}),
            style({opacity: 0.5, transform: 'scale(0.5)', transformOrigin: '50% 50%'}),
            style({opacity: 0.7, transform: 'scale(0.7)', transformOrigin: '50% 50%'}),
            style({opacity: 0.9, transform: 'scale(0.9)', transformOrigin: '50% 50%'}),
            style({opacity: 1, transform: 'scale(1)', transformOrigin: '50% 50%'}),
          ])
        ), { optional: true }),
      ]),
    ]),
    transition('showQCard => hideQCard', animate('200ms', keyframes([
      style({opacity: 1}),
      style({opacity: 0.8}),
      style({opacity: 0.6}),
      style({opacity: 0.4}),
      style({opacity: 0.2}),
      style({opacity: 0})
    ]))),
  ]),
  trigger('customAnimation', [
    state('hideCustom', style({transform: 'scale(0, 0)', opacity: 0})),
    state('showCustom', style({transform: 'scale(1, 1)', opacity: 1})),
    transition('hideCustom => showCustom', [
      query('#customCard1', style({opacity: 0})),
      query('#customCard2', style({opacity: 0})),
      query('#customCard3', style({opacity: 0})),
      style({opacity: 1, transform: 'scale(1, 1)'}),
      group([
      query('#customCard1', animate('200ms', keyframes([
        style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ]))),
      query('#customCard2', animate('200ms', keyframes([
        style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ]))),
      query('#customCard3', animate('200ms', keyframes([
        style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ])))])
    ]),
    transition('showCustom => hideCustom', animate('200ms', keyframes([
      style({opacity: 1, transform: 'scale(0.9, 0.9)'}),
      style({opacity: 0.8,  transform: 'scale(0.8, 0.8)'}),
      style({opacity: 0.6,  transform: 'scale(0.6, 0.6)'}),
      style({opacity: 0.4,  transform: 'scale(0.4, 0.4)'}),
      style({opacity: 0.2,  transform: 'scale(0.2, 0.2)'}),
      style({opacity: 0,  transform: 'scale(0.1, 0.1)'})
    ]))),
  ]),
  trigger('siteAnimation', [
    state('hideSite', style({transform: 'scale(0, 0)', opacity: 0})),
    state('showSite', style({transform: 'scale(1, 1)', opacity: 1})),
    transition('hideSite => showSite', [
      style({opacity: 1, transform: 'scale(1, 1)'}),
      query('.siteCard', style({opacity: 0})),
      query('#asideSiteTitle', style({opacity: 0})),
      query('#sitePath', style({opacity: 0})),
      query('.siteInformationBox', style({opacity: 0})),
      query('.siteCard', animate('200ms', keyframes([
        style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ]))),
      group([
        query('#asideSiteTitle', animate('500ms', keyframes([
          style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
          style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
          style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
          style({transform: 'scale(1, 1)', opacity: 1})
        ]))),
        query('.siteInformationBox', animate('500ms', keyframes([
          style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
          style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
          style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
          style({transform: 'scale(1, 1)', opacity: 1})
        ]))),
        query('#sitePath', animate('650ms', keyframes([
          style({height: '0.5rem', opacity: 1, transformOrigin: '50% 100%'}),
          style({height: '1.0rem', opacity: 1, transformOrigin: '50% 100%'}),
          style({height: '1.5rem', opacity: 1, transformOrigin: '50% 100%'}),
          style({height: '2.0rem', opacity: 1, transformOrigin: '50% 100%'}),
          style({height: '2.5rem', opacity: 1, transformOrigin: '50% 100%'}),
          style({height: '3.0rem', opacity: 1, transformOrigin: '50% 100%'}),
          style({height: '3.5rem', opacity: 1, transformOrigin: '50% 100%'}),
          style({height: '4.0rem', opacity: 1, transformOrigin: '50% 100%'}),
          style({height: '4.5rem', opacity: 1, transformOrigin: '50% 100%'}),
          style({height: '5.0rem', opacity: 1})
        ]))),
      ]),
    ]),
    transition('showSite => hideSite', animate('200ms', keyframes([
      style({opacity: 1, transform: 'scale(0.9, 0.9)'}),
      style({opacity: 0.8,  transform: 'scale(0.8, 0.8)'}),
      style({opacity: 0.6,  transform: 'scale(0.6, 0.6)'}),
      style({opacity: 0.4,  transform: 'scale(0.4, 0.4)'}),
      style({opacity: 0.2,  transform: 'scale(0.2, 0.2)'}),
      style({opacity: 0,  transform: 'scale(0.1, 0.1)'})
    ]))),
  ]),
  trigger('teamAnimation', [
    state('hideTeam', style({transform: 'scale(0, 0)', opacity: 0})),
    state('showTeam', style({transform: 'scale(1, 1)', opacity: 1})),
    transition('hideTeam => showTeam', [
      style({opacity: 1, transform: 'scale(1, 1)'}),
      query('.teamItem', style({opacity: 0})),
      query('.teamItem', animate('200ms', keyframes([
        style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ]))),
    ]),
    transition('showTeam => hideTeam', animate('200ms', keyframes([
      style({opacity: 1, transform: 'scale(0.9, 0.9)'}),
      style({opacity: 0.8,  transform: 'scale(0.8, 0.8)'}),
      style({opacity: 0.6,  transform: 'scale(0.6, 0.6)'}),
      style({opacity: 0.4,  transform: 'scale(0.4, 0.4)'}),
      style({opacity: 0.2,  transform: 'scale(0.2, 0.2)'}),
      style({opacity: 0,  transform: 'scale(0.1, 0.1)'})
    ]))),
  ]),
  ],
  templateUrl: './case-practice-p-and-o-event.component.html',
  styleUrls: ['./case-practice-p-and-o-event.component.css',]
})
export class CasePracticePAndOEventComponent implements OnInit, AfterViewInit {

  @Input() exerciseId:number;
  @Input() practiceId:number;
  @Input() practiceMetaId:number;
  @Input() learningPathId:number;
  @Input() practiceList:any
  //接受传入的参数 用于判断是否为访客
  @Input() userType:string;
  @Input() type:string;

  questionIndex: number;
  oldQuestionIndex: number;
  questions: any;
  currentQuestion: any;
  data: any;
  optionSelectedIndex:number;
  oldOptionSelectedIndex:number;
  characterArray: any;
  analysis: string;
  currentQuestionTitle: string;

  sortOptionsInitial: any;
  sortQuestionsAnswer: any;

  shortConversation: any;
  currentShortConversationIndex: number;
  currentShortConversation: string;
  oldShortConversationIndex:number;
  cardOnSubmit1: boolean;
  cardOnSubmit2: boolean;
  cardOnSubmit3: boolean;
  eventHistory: any;

  clickable: boolean;
  reportBtnShow: boolean;

  step: number;

  instruction: string;

  calculationMatrix: any;
  customerArray: any;
  timeArray: any;

  isActiveCalculationBtn: boolean;
  isActiveSortBtn: boolean;

  status: number;


  showId:number;

  completed: any;

  teacherShow: boolean;
  instructionShow: boolean;
  infoTableShow: boolean;
  decisionShow: boolean;
  diag1Show: boolean;
  diag2Show: boolean;
  wlnPhoneShow: boolean;
  fkkPhoneShow: boolean;
  fkkContentShow: boolean;
  taskTableShow: boolean;
  urgentShow: boolean;
  urgent2Show: boolean;
  qCardShow: boolean;
  customShow: boolean;
  siteShow: boolean;
  teamShow: boolean;
  optionClick: boolean; // 监听长按选项行为
  optionOnClick: boolean; // 监听用户是否按键
  optionClickTimeout: any; // 长按选项timeout

  meSelected: boolean;

  characterString: string;
  assetsRoute: string = "../../assets";

  constructor(

    private commonService:CommonService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router

  ){}

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.characterArray = ['A','B','C','D','E','F','G','H','I','J','K','L'];
    this.characterString = 'ABCDEFGH';
    this.clickable = false;
    this.teacherShow = false;
    this.instructionShow = false;
    this.infoTableShow = false;
    this.decisionShow = false;
    this.diag1Show = false;
    this.diag2Show = false;
    this.wlnPhoneShow = false;
    this.fkkPhoneShow = false;
    this.fkkContentShow = false;
    this.taskTableShow = false;
    this.urgentShow = false;
    this.urgent2Show = false;
    this.customShow = false;
    this.siteShow = false;
    this.teamShow = false;
    this.optionClick = false;
    this.optionOnClick = false;
    this.optionClickTimeout = null;
    this.cardOnSubmit1 = false;
    this.cardOnSubmit2 = false;
    this.cardOnSubmit3 = false;
    this.isActiveSortBtn = false;
    this.calculationMatrix=[
      {
          'role':'高朗',
          'experience':'3个月',
          'numberArray':[0,0,0,0]
      },
      {
          'role':'方科科',
          'experience':'2年',
          'numberArray':[0,0,0,0]
      },
      {
          'role':'秦飞',
          'experience':'8年',
          'numberArray':[0,0,0,0]
      },
      {
          'role':'我',
          'experience':'10年',
          'numberArray':[0,0,0,0]
      }
    ];
    this.customerArray = [6,9,1,18];
    this.timeArray = [60,30,60,15];
    this.eventHistory = [];
    this.apiService.ajax({
      'type':'get',
      'url':'/api/pnoQuestion/'+this.exerciseId
    }).subscribe(result=>{
      this.data = result;
      this.questions = this.data.questions;
      this.completed = this.data.completed;
      this.status = result.status;
      this.qCardShow = false;
      this.eventHistoryInit();
      this.eventInit();
    });


      /*this.data = this.getMockData();
      console.log(this.data);
      this.questions = this.data.questions;
      this.completed = this.data.completed;
      this.status = 55;
      this.eventHistoryInit();
      this.eventInit();*/
  }

  ngAfterViewInit(){
    this.commonService.initPage({
        'backgroundColor':'white'
    });
    document.oncontextmenu = function (e) {
        e.preventDefault();
    }
  }

  eventInit(){
    $('#reviewBtn').fadeIn(200);
    // console.log(this.status);
    // console.log("this status is" + this.status.toString());
    let _this = this;
    if(this.status==15){
      this.clickable = false;
      this.questionIndex = 0;
      this.currentQuestion = this.questions[this.questionIndex];
      this.currentQuestionTitle = this.currentQuestion.title[0];
      this.optionSelectedIndex = -1;
      this.showId = 1;
      this.eventHistory.push({
        'role':'问题1',
        'comment':this.currentQuestionTitle,
        'type': 1
      });
      setTimeout(function(){
        _this.qCardShow = true;
      }, 1000);
    }else if(this.status==20){
      this.questionIndex = 1;
      this.currentQuestion = this.questions[this.questionIndex];
      this.optionSelectedIndex = -1;
      if(this.completed[0].answer=='A'){
        this.currentQuestionTitle = this.currentQuestion.title[0].split(':')[1];
        this.setSortOptionsInitial();
        this.instruction = this.currentQuestion.task_list[0].split(':')[1];
        this.step = 108;
        this.showId = 2;
        setTimeout(function(){
          _this.instructionShow = true;
          setTimeout(function(){
            _this.clickable = true;
          }, 1000);
        }, 1000);
      }else{
        this.clickable = false;
        this.currentQuestionTitle = this.currentQuestion.title[1].split(':')[1];
        this.setSortOptionsInitial();
        this.step = 103;
        this.showId = 1;
        setTimeout(function(){
          _this.qCardShow = true;
        }, 1000);
      }
    }else if(this.status==25){
      this.questionIndex = 2;
      this.currentQuestion = this.questions[this.questionIndex];
      this.optionSelectedIndex = -1;
      this.step = 201;
      if(this.completed[1].answer==1234||this.completed[1].answer==1324){
        this.instruction = this.currentQuestion.task_list[0].split(':')[1];
      }else{
        this.instruction = this.currentQuestion.task_list[1].split(':')[1];
      }
      this.showId = 2;
      setTimeout(function(){
        _this.instructionShow = true;
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }, 1000);
    }else if(this.status==30){
      this.questionIndex = 2;
      this.currentQuestion = this.questions[this.questionIndex];
      if(this.completed[2].answer=='D'){
        this.instruction = this.currentQuestion.task_list[5].split('方科科:')[0].split(':')[1];
        this.showId = 2;
        this.step = 209;
        setTimeout(function(){
          _this.instructionShow = true;
          setTimeout(function(){
            _this.clickable = true;
          }, 1000);
        }, 1000);
      }else{
        if(this.completed[2].answer=='C'){
          this.currentShortConversation = this.currentQuestion.task_list[4].split(':')[2];
        }else{
          this.currentShortConversation = this.currentQuestion.task_list[3].split(':')[2];
        }
        this.showId = 3;
        this.step = 207;
        setTimeout(function(){
          _this.wlnPhoneShow = true;
          _this.diag1Show = true;
          setTimeout(function(){
            _this.clickable = true;
          }, 2000);
        }, 1000);
      }
    }else if(this.status==35){
      this.questionIndex = 3;
      this.currentQuestion = this.questions[this.questionIndex];
      if(this.completed[3].answer=='A'){
        this.currentShortConversationIndex = 1;
        this.currentShortConversation = this.currentQuestion.task_list[1].split('/')[0].split(':')[2];
        this.step = 304;
      }else{
        this.currentShortConversation = this.currentQuestion.task_list[2].split(':')[2];
        this.step = 307;
      }
      this.showId = 4;
      setTimeout(function(){
        _this.clickable = true;
      }, 1000);
      /*setTimeout(function(){

        _this.qCardShow = true;
        _this.clickable = false;

      }, 250);*/

    }else if(this.status==40){
      this.questionIndex = 5;
      this.currentQuestion = this.questions[this.questionIndex];
      if(this.completed[4].answer=='B'){
        /*this.calculationMatrix.pop();*/
        this.meSelected = false;
      }else{
        this.meSelected = true;
      }
      this.showId = 5;
      this.step = 501;
      this.clickable = false;
    }else if(this.status==45){
      this.questionIndex = 6;
      this.currentQuestion = this.questions[this.questionIndex];
      this.instruction = this.currentQuestion.title[0];
      this.step = 601;
      this.showId = 2;
      setTimeout(function(){
        _this.instructionShow = true;
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }, 1000);

    }else if(this.status == 50){
      this.questionIndex = 6;
      this.currentQuestion = this.questions[this.questionIndex];
      let temp = this.completed[6].answer;
      this.currentQuestion.task_list.forEach(function (item,index) {
        if(item.indexOf(temp)!=-1){
          _this.instruction = item.split(':')[1];
        }
      });
      this.showId = 2;
      this.step = 605;
      setTimeout(function(){
        _this.instructionShow = true;
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }, 1000);
    }else if(this.status == 55){
      this.questionIndex = 7;
      this.currentQuestion = this.questions[this.questionIndex];
      this.instruction = this.currentQuestion.task_list[0];
      this.showId = 2;
      this.step = 703;
      this.reportBtnShow = true;
      this.qCardShow = false;
      setTimeout(function(){
        _this.instructionShow = true;
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }, 1000);
    }
    /*this.setHeight();*/
  }

  eventHistoryInit(){
      this.eventHistory15();
      if(!this.userType){
        if(this.status==20){
          this.eventHistory20();
        }else if(this.status == 25){
          this.eventHistory20();
          this.eventHistory25();
        }else if(this.status == 30){
          this.eventHistory20();
          this.eventHistory25();
          this.eventHistory30();
        }else if(this.status == 35){
          this.eventHistory20();
          this.eventHistory25();
          this.eventHistory30();
          this.eventHistory35();
        }else if(this.status == 40){
          this.eventHistory20();
          this.eventHistory25();
          this.eventHistory30();
          this.eventHistory35();
          this.eventHistory40();
        }else if(this.status == 45){
          this.eventHistory20();
          this.eventHistory25();
          this.eventHistory30();
          this.eventHistory35();
          this.eventHistory40();
          this.eventHistory45();
        }else if(this.status == 50){
          this.eventHistory20();
          this.eventHistory25();
          this.eventHistory30();
          this.eventHistory35();
          this.eventHistory40();
          this.eventHistory45();
          this.eventHistory50();
        }else if(this.status == 55){
          this.eventHistory20();
          this.eventHistory25();
          this.eventHistory30();
          this.eventHistory35();
          this.eventHistory40();
          this.eventHistory45();
          this.eventHistory50();
          this.eventHistory55();
        }
      }

  }

  eventHistory15(){
      let that = this;
      this.eventHistory.push({
          'role':'任务详情',
          'comment': that.questions[0].task_list[5]+'<br/><br/>'+that.questions[0].task_list[6]+that.questions[0].task_list[7]+that.questions[0].task_list[8]+that.questions[0].task_list[9],
          'type':9,
          'mode': 0
      },{
          'role':'时间表',
          'comment': that.questions[0].task_list[10],
          'type':9,
          'mode': 0
      })

  }

  eventHistory20(){
      let that = this;
      let answer = that.completed[0].answer;
      let optionIndex = answer.charCodeAt(0) - 'A'.charCodeAt(0);
      let analysis;
      this.questions[0].director_comment.forEach(function (item,index) {
          if(item.indexOf(answer)!=-1){
              analysis = item.split(':')[1];
          }
      });
      this.eventHistory.push({
          'role':'问题1',
          'comment': that.questions[0].title[0],
          'type': 1
      },{
          'role':'你的答案',
          'comment': that.questions[0].options[optionIndex],
          'type':4
      },{
          'role':'导师点评',
          'comment':analysis,
          'type':5
      });
      if(answer=='A'){
          this.eventHistory.push({
              'role':'情节',
              'comment': that.questions[1].task_list[0],
              'type': 2
          });
      }else{
          this.eventHistory.push({
              'role':'排序题',
              'comment': that.questions[1].title[1].split(':')[1],
              'type': 1
          });
      }
  }

  eventHistory25(){
    let that = this;
    let lastQuestionAnswer = that.completed[0].answer;
    if(lastQuestionAnswer == 'A'){
        this.eventHistory.push({
            'role':'信息表',
            'comment':that.questions[1].task_list[1].split(':')[1],
            'type': 9,
            'mode': 0
        },{
            'role':'排序题',
            'comment': that.questions[1].title[0].split(':')[1],
            'type': 1
        });
    }
    let answerNumber = this.completed[1].answer;
    let answerArray = [];
    for(let i=0;i<4;i++){
      answerArray.push(this.questions[1].options[parseInt(answerNumber[i])-1]);
    }
    let currentComment;
    if(answerNumber==1234||answerNumber==1324){
        currentComment = that.questions[2].task_list[0].split(':')[1];
    }else{
        currentComment = that.questions[2].task_list[1].split(':')[1];
    }
      this.eventHistory.push({
          'role':'你的答案',
          'comment':answerArray,
          'type':4
      },{
          'role':'导师点评',
          'comment':that.questions[1].director_comment,
          'type':5
      },{
          'role':'情节',
          'comment':currentComment,
          'type':2
      });
  }

  eventHistory30(){
    let that = this;
      this.eventHistory.push({
          'role':'决定',
          'comment':that.questions[2].task_list[2],
          'type': 9,
          'mode': 0
      },{
          'role':'情节',
          'comment':that.questions[2].title[0],
          'type':2
      });
      let temp = this.questions[2].title[1].split('/');
      temp.forEach(function (item){
          that.eventHistory.push({
              'role':item.split(':')[0],
              'comment':item.split(':')[1],
              'type': 3
          });
      });
      let answer = that.completed[2].answer;
      let optionIndex = answer.charCodeAt(0) - 'A'.charCodeAt(0);
      this.eventHistory.push({
          'role':'你的答案',
          'comment': that.questions[2].options[optionIndex],
          'type':4
      },{
          'role':'导师点评',
          'comment':that.questions[2].director_comment[0],
          'type':5
      });
      if(answer=='A'||answer=='B'){
          this.eventHistory.push({
              'role':'王丽娜',
              'comment':that.questions[2].task_list[3].split(':')[2],
              'type': 3
          });
      }else if(answer=='C'){
          this.eventHistory.push({
              'role':'王丽娜',
              'comment':that.questions[2].task_list[4].split(':')[2],
              'type': 3
          });
      }else{
          this.eventHistory.push({
              'role':'情节',
              'comment':that.questions[2].task_list[5].split('方科科:')[0].split(':')[1],
              'type': 2
          });
      }
  }

  eventHistory35(){
      let that = this;
      let lastQuestionAnswer = this.completed[2].answer;
      if(lastQuestionAnswer=='D'){
          this.eventHistory.push({
              'role':'方科科',
              'comment':that.questions[2].task_list[5].split('方科科:')[1],
              'type': 3
          });
      }
      let answer = this.completed[3].answer;
      let optionIndex = answer.charCodeAt(0) - 'A'.charCodeAt(0);
      let analysis;
      this.questions[3].director_comment.forEach(function (item,index) {
          if(item.indexOf(answer)!=-1){
              analysis = item.split(':')[1];
          }
      });
      let myWord;
      if(answer=='A'){
          myWord = this.questions[3].task_list[1].split('/')[0].split(':')[2];
      }else{
        myWord = this.questions[3].task_list[2].split(':')[2];
      }
      this.eventHistory.push({
          'role':'情节',
          'comment':that.questions[2].task_list[6],
          'type': 2
      },{
          'role':'任务表',
          'comment': that.questions[3].task_list[0],
          'type':9,
          'mode': 0
      },{
          'role':'问题',
          'comment': that.questions[3].title[0],
          'type': 1
      },{
          'role':'你的答案',
          'comment': that.questions[3].options[optionIndex],
          'type':4
      },{
          'role':'导师点评',
          'comment':analysis,
          'type':5
      },{
          'role':'我',
          'comment':myWord,
          'type': 3
      });
  }

  eventHistory40(){
      let that = this;
      let lastQuestionAnswer = this.completed[3].answer;
      if(lastQuestionAnswer=='A'){
          this.eventHistory.push({
              'role':'秦飞',
              'comment':that.questions[3].task_list[1].split('/')[1].split(':')[1],
              'type': 3
          },{
              'role':'我',
              'comment':that.questions[3].task_list[1].split('/')[2].split(':')[1],
              'type': 3
          });
      }

      let answer = this.completed[4].answer;
      let optionIndex = answer.charCodeAt(0) - 'A'.charCodeAt(0);
      let analysis;
      this.questions[4].director_comment.forEach(function (item,index) {
          if(item.indexOf(answer)!=-1){
              analysis = item.split(':')[1];
          }
      });
      this.eventHistory.push({
          'role':'情节',
          'comment':that.questions[4].task_list[0],
          'type': 2
      },{
          'role':'客户信息',
          'comment': that.questions[5].title[0],
          'type':9,
          'mode': 0
      },{
          'role':'场地信息',
          'comment': that.questions[5].title[1]+that.questions[5].title[2],
          'type':9,
          'mode': 0
      },{
          'role':'团队信息',
          'comment': that.questions[5].title[3],
          'type':9,
          'mode': 0
      },{
          'role':'情节',
          'comment': '秦飞因为水土不服，到了旧金山就上吐下泻，身体很虚弱。',
          'type': 2
      },{
          'role':'问题',
          'comment': that.questions[4].title[0],
          'type': 1
      },{
          'role':'你的答案',
          'comment': that.questions[4].options[optionIndex],
          'type':4
      },{
          'role':'导师点评',
          'comment':analysis,
          'type':5
      });

  }

  eventHistory45(){
      let that = this;
      this.eventHistory.push({
          'role':'情节',
          'comment':that.questions[6].title[0],
          'type': 2
      });
  }

  eventHistory50(){
      let that = this;
      let answer = this.completed[6].answer;
      let optionIndex = answer.charCodeAt(0) - 'A'.charCodeAt(0);
      let commentCurrent;
      this.questions[6].task_list.forEach(function (item,index) {
          if(item.indexOf(answer)!=-1){
              commentCurrent = item.split(':')[1];
          }
      });
      this.eventHistory.push({
          'role':'方科科',
          'comment':that.questions[6].title[1].split(':')[1],
          'type': 3
      },{
          'role':'你的答案',
          'comment': that.questions[6].options[optionIndex],
          'type':4
      },{
          'role':'导师点评',
          'comment': that.questions[6].director_comment[0],
          'type':5
      },{
          'role':'情节',
          'comment': commentCurrent,
          'type': 2
      });
  }

  eventHistory55(){
      let that = this;
      let answer = this.completed[7].answer;
      let optionIndex = answer.charCodeAt(0) - 'A'.charCodeAt(0);
      this.eventHistory.push({
          'role':'问题',
          'comment':that.questions[7].title[0],
          'type': 1
      },{
          'role':'你的答案',
          'comment': that.questions[7].options[optionIndex],
          'type':4
      },{
          'role':'导师点评',
          'comment': that.questions[7].director_comment[0],
          'type':5
      },{
          'role': '情节',
          'comment': that.questions[7].task_list[0],
          'type':2
      });
  }

  screenClick(){
    let _this = this;
    // console.log("step is" + this.step.toString());
    // console.log(this.clickable);
    if(!this.clickable){
      return;
    }
		//回顾修改
    if(!this.clickDialogEnable){
    	return false;
    }
    // console.log(this.step);
    if(this.step==101){
      let temp = this.characterArray[this.oldOptionSelectedIndex];
      let tempQuestion;
      this.clickable = false;
      this.step = 108;
      this.oldQuestionIndex = this.questionIndex;
      this.oldOptionSelectedIndex = this.optionSelectedIndex;
      if(this.questionIndex==4){
          this.questionIndex+=2;
      }else{
          this.questionIndex++;
      }
      this.optionSelectedIndex = -1;
      tempQuestion = this.questions[this.questionIndex];
      this.currentQuestion = tempQuestion;
      tempQuestion.title.forEach(function (item,index) {
        if(item.indexOf(temp)!=-1){
          _this.currentQuestionTitle = item.split(':')[1];
        }
      });
      this.setSortOptionsInitial();
      this.instruction = this.currentQuestion.task_list[0].split(':')[1];
      $('#teacherPic').fadeOut(200);
      this.teacherShow = false;
      setTimeout(function () {
        _this.instructionShow = true;
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }, 1000);
      this.eventHistory.push({
        'role':'情节',
        'comment':this.instruction,
          'type': 2
      });
    }else if(this.step==102){
      let temp = this.characterArray[this.oldOptionSelectedIndex];
      let tempQuestion;
      this.clickable = false;
      this.step = 103;
      this.oldQuestionIndex = this.questionIndex;
      this.oldOptionSelectedIndex = this.optionSelectedIndex;
      if(this.questionIndex==4){
          this.questionIndex+=2;
      }else{
          this.questionIndex++;
      }
      this.optionSelectedIndex = -1;
      tempQuestion = this.questions[this.questionIndex];
      this.currentQuestion = tempQuestion;
      tempQuestion.title.forEach(function (item,index) {
        if(item.indexOf(temp)!=-1){
            _this.currentQuestionTitle = item.split(':')[1];
        }
      });
      this.setSortOptionsInitial();
      $('#teacherPic').fadeOut(200);
      this.teacherShow = false;
      setTimeout(function () {
        _this.qCardShow = true;
      }, 1000);
      this.eventHistory.push({
        'role':'问题',
        'comment':this.currentQuestionTitle,
          'type': 1
      });
    }else if(this.step == 108){
      let tempQuestion = this.currentQuestion;
      this.clickable = false;
      this.step = 109;
      this.instructionShow = false;
      setTimeout(function () {
        _this.infoTableShow = true;
        setTimeout(function(){
          _this.clickable = true;
        },  1000);
      }, 1000);
      this.eventHistory.push({
        'role':'信息表',
        'comment': tempQuestion.task_list[1],
          'type': 9,
          'mode': 0
      });
    }else if(this.step == 109){
      this.clickable = false;
      this.step = 103;
      this.infoTableShow = false;
      setTimeout(function () {
        _this.qCardShow = true;
        // _this.clickable = false;
      }, 1000);
      this.eventHistory.push({
        'role':'问题',
        'comment':this.currentQuestionTitle,
        'type': 1
      });
   }else if(this.step == 104){
      let tempQuestion;
      this.clickable = false;
      this.step = 201;
      this.oldQuestionIndex = this.questionIndex;
      this.oldOptionSelectedIndex = this.optionSelectedIndex;
      if(this.questionIndex==4){
          this.questionIndex+=2;
      }else{
          this.questionIndex++;
      }
      this.optionSelectedIndex = -1;
      tempQuestion = this.questions[this.questionIndex];
      this.currentQuestion = tempQuestion;
      if(this.sortQuestionsAnswer==1234 || this.sortQuestionsAnswer==1324){
        this.instruction = tempQuestion.task_list[0].split(':')[1];
      }else{
        this.instruction = tempQuestion.task_list[1].split(':')[1];
      }
      $('#teacherPic').fadeOut(200);
      this.teacherShow = false;
      this.eventHistory.push({
        'role':'情节',
        'comment':this.instruction,
          'type': 2
      });
      setTimeout(function () {
        _this.instructionShow = true;
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }, 1000);
    }else if(this.step == 201){
      let tempQuestion = this.currentQuestion;
      this.clickable = false;
      this.step = 202;
      this.instructionShow = false;
      setTimeout(function () {
        _this.decisionShow = true;
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }, 1000);
      this.eventHistory.push({
          'role':'决定',
          'comment':tempQuestion.task_list[2],
          'type': 9,
          'mode': 0
      });
    }else if(this.step == 202){
      let tempQuestion = this.currentQuestion;
      this.clickable = false;
      this.step = 203;
      this.decisionShow = false;
      this.instruction = tempQuestion.title[0];
      let temp = tempQuestion.title[1].split('/');
      this.shortConversation = [];
      temp.forEach(function (item,index){
        _this.shortConversation.push({
          'role':item.split(':')[0],
          'comment':item.split(':')[1]
        });
      });
      this.currentShortConversationIndex = 0;
      setTimeout(function () {
        _this.instructionShow = true;
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }, 1000);
      this.eventHistory.push({
        'role':'情节',
        'comment':this.instruction,
        'type':2
      });
    }else if(this.step == 203){
      this.clickable = false;
      if(this.userType){
        $("#shade2").fadeIn();
        $('#tip2').fadeIn();
      }else{
        if(this.currentShortConversationIndex==0){
          this.instructionShow = false;
          setTimeout(function() {
            _this.wlnPhoneShow = true;
            setTimeout(function(){
              _this.diag1Show = true;
              _this.currentShortConversation = _this.shortConversation[_this.currentShortConversationIndex].comment;
              _this.currentShortConversationIndex++;
              _this.eventHistory.push({
                'role':'王立娜',
                'comment':_this.currentShortConversation,
                'type':3
              });
              setTimeout(function(){
                _this.clickable = true;
              }, 1500);
            }, 2000);
          }, 1000);
        }else if(this.currentShortConversationIndex==2){
          this.diag2Show = false;
          setTimeout(function () {
            _this.currentShortConversation = _this.shortConversation[_this.currentShortConversationIndex].comment;
            _this.diag1Show = true;
            _this.step = 204;
            _this.eventHistory.push({
              'role':'王立娜',
              'comment':_this.currentShortConversation,
              'type':3
            });
            setTimeout(function(){
              _this.clickable = true;
            }, 800);
          }, 800);
        }else if(this.currentShortConversationIndex==1){
          this.diag1Show = false;
          setTimeout(function () {
            _this.currentShortConversation = _this.shortConversation[_this.currentShortConversationIndex].comment;
            _this.diag2Show = true;
            _this.currentShortConversationIndex++;
            _this.eventHistory.push({
              'role':'我',
              'comment':_this.currentShortConversation,
              'type':3
            });
            setTimeout(function(){
              _this.clickable = true;
            }, 800);
          }, 800);
        }
      }
    }else if(this.step == 204){
      this.clickable = false;
      this.step = 205;
      // this.wlnPhoneShow = false;
      $('#wlnTelephone').fadeOut(200);
      this.diag1Show = false;
      setTimeout(function () {
        $('#optionsWrap2').fadeIn(200);
        // setTimeout(function(){
        //   _this.clickable = true;
        // }, 650);
      }, 1000);
    }else if(this.step == 206){
      let tempQuestion = this.currentQuestion;
      this.clickable = false;
      if(this.optionSelectedIndex==3){
        $('#teacherPic').fadeOut(200);
        this.teacherShow = false;
        this.instruction = tempQuestion.task_list[5].split('方科科:')[0].split(':')[1];
        setTimeout(function (){
          _this.instructionShow = true;
          _this.step = 209;
          _this.eventHistory.push({
              'role':'情节',
              'comment':_this.instruction,
              'type':2
          });
          setTimeout(function(){
            _this.clickable = true;
          }, 1000);
        }, 1000);
      }else{
        if(this.optionSelectedIndex==2){
          this.currentShortConversation = tempQuestion.task_list[4].split(':')[2];
        }else{
          this.currentShortConversation = tempQuestion.task_list[3].split(':')[2];
        }
        $('#teacherPic').fadeOut(200);
        this.teacherShow = false;
        setTimeout(function () {
          // _this.wlnPhoneShow = true;
          $('#wlnTelephone').fadeIn(200);
          setTimeout(function(){
            _this.diag1Show = true;
            _this.step = 207;
            _this.eventHistory.push({
              'role':'王立娜',
              'comment':_this.currentShortConversation,
              'type':3
            });
            setTimeout(function(){
              _this.clickable = true;
            }, 1000);
          }, 1000);
        }, 1000);
      }
    }else if(this.step == 207){
      let tempQuestion = this.currentQuestion;
      this.clickable = false;
      $('#wlnTelephone').fadeOut(200);
      this.diag1Show = false;
      this.instruction = tempQuestion.task_list[6]
      setTimeout(function () {
        _this.instructionShow = true;
        _this.step = 208;
        _this.eventHistory.push({
            'role':'情节',
            'comment': _this.instruction,
            'type':2
        });
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
        $('#wrap').css('background-image', 'url("../../assets/picture/casepracticepando/bg4.png")');
      }, 800);
    }else if(this.step == 208){
      let tempQuestion = this.currentQuestion;
      this.clickable = false;
      this.step = 301;
      this.instructionShow = false;
      this.currentQuestionTitle = tempQuestion.title[0];
      setTimeout(function () {
        _this.taskTableShow = true;
        _this.resetQuestion();
        _this.eventHistory.push({
            'role':'任务表',
            'comment': _this.questions[3].task_list[0],
            'type':9,
            'mode': 0
        });
        // setTimeout(function(){
        //   _this.clickable = true;
        // }, 1000);
      }, 1000);
    }else if(this.step == 209){
      let tempQuestion = this.currentQuestion;
      this.clickable = false;
      this.step = 210;
      this.instructionShow = false;
      this.currentShortConversation = tempQuestion.task_list[5].split('方科科:')[1];
      setTimeout(function () {
        $('#fkk2').fadeIn(200);
        _this.fkkContentShow = true;
        _this.eventHistory.push({
            'role':'方科科',
            'comment': _this.currentShortConversation,
            'type':3
        });
        setTimeout(function(){
          _this.clickable = true;
        }, 800);
      }, 1000);
    }else if(this.step==210){
      let tempQuestion = this.currentQuestion;
      this.clickable = false;
      $('#fkk2').fadeOut(200);
      this.fkkContentShow = false;
      this.instruction = tempQuestion.task_list[6];
      setTimeout(function () {
        _this.instructionShow = true;
        _this.step = 208;
        _this.eventHistory.push({
          'role':'情节',
          'comment': _this.instruction,
          'type':2
        });
        $('#wrap').css('background-image', 'url("../../assets/picture/casepracticepando/bg4.png")');
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }, 800);
    }else if(this.step==301){
      this.clickable = false;
      this.step = 303;
      this.taskTableShow = false;
      setTimeout(function () {
        _this.urgentShow = true;
        setTimeout(function(){
          $("#boo").fadeIn(10);
          $("#urgentText").fadeIn(200);
          setTimeout(function(){
            this.urgentShow = false;
            $("#urgent").fadeOut(200);
            $("#boo").fadeOut(200);
            $("#urgentText").fadeOut(200);
            setTimeout(function () {
              _this.qCardShow = true;
              // _this.clickable = false;
              _this.urgent2Show = true;
              _this.eventHistory.push({
                'role':'问题',
                'comment': _this.currentQuestionTitle,
                'type':1
              });
            },350);
          }, 1150);
        }, 250);
      }, 1000);
    }else if(this.step == 302){
      this.clickable = false;
      this.step = 303;
      this.urgentShow = false;
      $("#boo").fadeOut(200);
      $("#urgentText").fadeOut(200);
      setTimeout(function () {
        _this.qCardShow = true;
        // _this.clickable = false;
        _this.eventHistory.push({
          'role':'问题',
          'comment': _this.currentQuestionTitle,
          'type':1
        });
      }, 800);
    }else if(this.step == 304){
      let tempQuestion = this.currentQuestion;
      this.clickable = false;
      if(this.currentShortConversationIndex == 0){
        $('#teacherPic').fadeOut(200);
        this.teacherShow = false;
        this.currentShortConversation = tempQuestion.task_list[1].split('/')[0].split(':')[2];
        setTimeout(function () {
          $('#gl').fadeIn(200);
          /*$('#wln').fadeIn(200);*/
          $('#fkk').fadeIn(200);
          $('#qf').fadeIn(200);
          $('#dialogueBox3').fadeIn(200);
          _this.currentShortConversationIndex++;
          _this.eventHistory.push({
              'role':'我',
              'comment': _this.currentShortConversation,
              'type':3
          });
          setTimeout(function(){
            _this.clickable = true;
          }, 1000);
        }, 1000);
      }else if(this.currentShortConversationIndex == 1){
        $('#gl').fadeOut(200);
        /*$('#wln').fadeOut(200);*/
        $('#fkk').fadeOut(200);
        $('#qf').fadeOut(200);
        $('#dialogueBox3').fadeOut(200);
        this.currentShortConversation = tempQuestion.task_list[1].split('/')[1].split(':')[1];
        setTimeout(function () {

          _this.showQFDialog();
          _this.currentShortConversationIndex++;
          _this.eventHistory.push({
              'role':'秦飞',
              'comment': _this.currentShortConversation,
              'type':3
          });
          setTimeout(function(){
            _this.clickable = true;
          }, 1000);
        }, 1000);
      }else if(this.currentShortConversationIndex == 2){
        this.hideQFDialog();
        this.currentShortConversation = tempQuestion.task_list[1].split('/')[2].split(':')[1];
        setTimeout(function () {
          $('#dialogueBox3').fadeIn(200);
          _this.currentShortConversationIndex++;
          _this.step = 306;
          _this.eventHistory.push({
              'role':'我',
              'comment': _this.currentShortConversation,
              'type':3
          });
          setTimeout(function(){
            _this.clickable = true;
          }, 1000);
        }, 1000);
      }
    }else if(this.step == 305){
      let tempQuestion = this.currentQuestion;
      this.clickable = false;
      this.step = 307;
      $('#teacherPic').fadeOut(200);
      this.teacherShow = false;
      this.currentShortConversation = tempQuestion.task_list[2].split(':')[2];
      this.eventHistory.push({
          'role':'我',
          'comment': this.currentShortConversation,
          'type':3
      });
      setTimeout(function(){
        $('#gl').fadeIn(200);
        /*$('#wln').fadeIn(200);*/
        $('#fkk').fadeIn(200);
        $('#qf').fadeIn(200);
        $('#dialogueBox3').fadeIn(200);
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }, 1000);
    }else if(this.step==306){
      let tempQuestion;
      this.clickable = false;
      this.step = 401;
      this.oldQuestionIndex = this.questionIndex;
      this.oldOptionSelectedIndex = this.optionSelectedIndex;
      if(this.questionIndex==4){
          this.questionIndex+=2;
      }else{
          this.questionIndex++;
      }
      this.optionSelectedIndex = -1;
      tempQuestion = this.questions[this.questionIndex];
      this.currentQuestion = tempQuestion;
      $('#dialogueBox3').fadeOut(200);
      $('#qf2').fadeOut(200);
      this.instruction = tempQuestion.task_list[0]
      setTimeout(function () {
        _this.instructionShow = true;
        $('#wrap').css('background-image', 'url("../../assets/picture/casepracticepando/bg3.png")');
        _this.eventHistory.push({
          'role':'情节',
          'comment': _this.instruction,
          'type':2
        });
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }, 800);
    }else if(this.step==307){
      let tempQuestion = this.currentQuestion;
      this.clickable = false;
      this.step = 401;
      this.oldQuestionIndex = this.questionIndex;
      this.oldOptionSelectedIndex = this.optionSelectedIndex;
      if(this.questionIndex==4){
          this.questionIndex+=2;
      }else{
          this.questionIndex++;
      }
      this.optionSelectedIndex = -1;
      tempQuestion = this.questions[this.questionIndex];
      this.currentQuestion = tempQuestion;
      $('#dialogueBox3').fadeOut(200);
      $('#gl').fadeOut(200);
      /*$('#wln').fadeOut(200);*/
      $('#fkk').fadeOut(200);
      $('#qf').fadeOut(200);
      this.instruction = tempQuestion.task_list[0];
      this.eventHistory.push({
          'role':'情节',
          'comment': this.instruction,
          'type':2
      });
      setTimeout(function () {
        _this.instructionShow = true;
        $('#wrap').css('background-image', 'url("../../assets/picture/casepracticepando/bg3.png")');
        setTimeout(function(){
          _this.clickable = true;
        }, 1200);
      }, 1000);
    }else if(this.step == 401){
      this.clickable = false;
      this.step = 402;
      this.instructionShow = false;
      this.eventHistory.push({
        'role':'客户信息',
        'comment': this.questions[5].title[0],
        'type':9,
        'mode': 0
      });
      setTimeout(function () {
        _this.customShow = true;
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }, 1000);
    }else if(this.step == 402){
      this.clickable = false;
      this.step = 403;
      this.customShow = false;
      setTimeout(function () {
        _this.siteShow = true;
        _this.eventHistory.push({
          'role':'场地信息',
          'comment': _this.questions[5].title[1]+_this.questions[5].title[2],
          'type':9,
          'mode': 0
        });
        setTimeout(function(){
          _this.clickable = true;
        }, 1500);
      }, 1000);
    }else if(this.step == 403){
      this.clickable = false;
      this.step = 404;
      this.siteShow = false;
      setTimeout(function () {
        _this.teamShow = true;
        _this.eventHistory.push({
          'role':'团队信息',
          'comment': _this.questions[5].title[3],
          'type':9,
          'mode': 0
        });
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }, 1000);
    }else if(this.step == 404){
      this.clickable = false;
      this.step = 405;
      this.teamShow = false;
      setTimeout(function () {
        _this.instruction = '秦飞因为水土不服，到了旧金山就上吐下泻，身体很虚弱。';
        _this.instructionShow = true;
        _this.eventHistory.push({
            'role':'情节',
            'comment': _this.instruction,
            'type':2
        });
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }, 1000);
    }else if(this.step==405){
      this.clickable = false;
      let tempQuestion = this.currentQuestion;
      this.step = 406;
      this.instructionShow = false;
      this.currentQuestionTitle = tempQuestion.title[0];
      setTimeout(function () {
        _this.qCardShow = true;
        // _this.clickable = false;
        _this.eventHistory.push({
          'role':'题目',
          'comment': _this.currentQuestionTitle,
          'type':1
        });
      }, 1000);
    }else if(this.step == 407){
      this.clickable = false;
      this.step = 501;
      $('#teacherPic').fadeOut(200);
      this.teacherShow = false;
      $('#reviewBtn').fadeOut(200);
      setTimeout(function () {
        $('#calculationWrap').fadeIn(200);
      }, 1000);
    }else if(this.step == 601){
      let tempQuestion = this.currentQuestion;
      this.clickable = false;
      this.step = 602;
      this.instructionShow = false;
      this.currentShortConversation = tempQuestion.title[1].split(':')[1];
      setTimeout(function () {
        _this.fkkPhoneShow = true;
        setTimeout(function(){
          _this.diag1Show = true;
          _this.eventHistory.push({
            'role':'方科科',
            'comment': _this.currentShortConversation,
            'type':3
          });
          setTimeout(function(){
            _this.clickable = true;
          }, 1000);
        }, 2000);
      }, 1000);
    }else if(this.step==602){
      this.clickable = false;
      this.step = 603;
      this.fkkPhoneShow = false;
      this.diag1Show = false;
      setTimeout(function () {
        $('#optionsWrap2').fadeIn(200);
      }, 1000);
    }else if(this.step==604){
      let tempQuestion = this.currentQuestion;
      this.clickable = false;
      this.step = 605;
      $('#teacherPic').fadeOut(200);
      this.teacherShow = false;
      setTimeout(function () {
        let temp = _this.characterArray[_this.optionSelectedIndex];
        tempQuestion.task_list.forEach(function (item,index) {
            if(item.indexOf(temp)!=-1){
                _this.instruction = item.split(':')[1];
            }
        });
        _this.instructionShow = true;
        _this.eventHistory.push({
            'role':'情节',
            'comment': _this.instruction,
            'type':2
        });
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }, 800);
    }else if(this.step == 605){
      let tempQuestion;
      this.clickable = false;
      this.step = 701;
      this.instructionShow = false;
      this.oldQuestionIndex = this.questionIndex;
      this.oldOptionSelectedIndex = this.optionSelectedIndex;
      if(this.questionIndex==4){
          this.questionIndex+=2;
      }else{
          this.questionIndex++;
      }
      this.optionSelectedIndex = -1;
      tempQuestion = this.questions[this.questionIndex];
      this.currentQuestion = tempQuestion;
      this.currentQuestionTitle = tempQuestion.title[0];
      setTimeout(function () {
        // _this.clickable = false;
        _this.qCardShow = true;
        _this.eventHistory.push({
          'role':'题目',
          'comment': _this.currentQuestionTitle,
          'type':1
        });
      }, 1000);
    }else if(this.step == 702){
      let tempQuestion = this.currentQuestion;
      this.clickable = false;
      this.step = 703;
      $('#teacherPic').fadeOut(200);
      this.teacherShow = false;
      this.instruction = tempQuestion.task_list[0];
      setTimeout(function () {
        _this.instructionShow = true;
        $('#reportBtn').fadeIn(200);
        $('#wrap').css('background-image', 'url("../../assets/picture/casepracticepando/bg2.png")');
        _this.eventHistory.push({
          'role':'情节',
          'comment': _this.instruction,
          'type':2
        });
        setTimeout(function(){
          _this.clickable = false;
        }, 1000);
      }, 1000);
    }
  }

  onOptionClick($event,i){

    $event.stopPropagation();
    this.optionSelectedIndex = i;

  }

  resetQuestion(){
    let _this = this;
    this.oldQuestionIndex = this.questionIndex;
    this.oldOptionSelectedIndex = this.optionSelectedIndex;
    if(this.questionIndex==4){
        this.questionIndex+=2;
    }else{
        this.questionIndex++;
    }
    this.optionSelectedIndex = -1;
    this.currentQuestion = this.questions[this.questionIndex];
    this.currentQuestionTitle = this.currentQuestion.title[0];
    setTimeout(function(){
      _this.clickable = true;
    }, 500);
  }

  arrowDownClick(i){
    let temp = this.currentQuestion.options[i];
    let tempNext = this.currentQuestion.options[i+1];
    this.currentQuestion.options[i] = tempNext;
    this.currentQuestion.options[i+1] = temp;
  }

  arrowUpClick(i){
      let temp = this.currentQuestion.options[i];
      let tempPrevious = this.currentQuestion.options[i-1];
      this.currentQuestion.options[i] = tempPrevious;
      this.currentQuestion.options[i-1] = temp;
  }

  setSortOptionsInitial(){
    let _this = this;
      this.sortOptionsInitial = [];
      this.currentQuestion.options.forEach(function (item,index) {
          _this.sortOptionsInitial.push({
              'id': index+1,
              'option': item
          });
      });

      this.currentQuestion.options = [this.sortOptionsInitial[1].option,this.sortOptionsInitial[0].option,this.sortOptionsInitial[3].option,this.sortOptionsInitial[2].option];
  }


  getSortOptionIdByContent(option){
    let temp;
    this.sortOptionsInitial.forEach(function (item,index) {
        if(item.option==option){
            temp = item.id
        }
    });
    return temp;
  }

  onQuestionBtnClick($event){
    $event.stopPropagation();
    let that = this;
    // console.log("Question Button Clicked");
    if(this.optionSelectedIndex<0){
      return;
    }
    if(this.cardOnSubmit1){
      return;
    }else{
      console.log("submit");
      this.cardOnSubmit1 = true;
    }
    if(this.step == 303){
      this.urgent2Show = false;
    }
    let pointId;
    if(this.questionIndex==0){
      pointId = 20;
    }else if(this.questionIndex == 3){
      pointId = 35;
    }else if(this.questionIndex == 4){
      pointId = 40;
    }else if(this.questionIndex == 7){
      pointId = 55;
    }
    this.apiService.ajax({
      'type':'post',
      'url':'/api/pnoQuestion/'+this.exerciseId,
      'data':{
        'pno_question_id':this.currentQuestion.id,
        'pno_answer':this.characterArray[this.optionSelectedIndex]
      }
    }).subscribe(result=>{
      this.apiService.ajax({
        'type':'post',
        'url':'/api/pnoStorePoint/'+this.exerciseId,
        'data':{
          'pno_store_point_id':pointId
        }
      }).subscribe(result=>{
      	this.oldQuestionIndex = this.questionIndex;
        this.oldOptionSelectedIndex = this.optionSelectedIndex;
        if(this.questionIndex==0||this.questionIndex==3||this.questionIndex==4){
          let tempQuestion = this.currentQuestion;
          let temp = this.characterArray[this.optionSelectedIndex];
          tempQuestion.director_comment.forEach(function (item,index){
            if(item.indexOf(temp)!=-1){
              that.analysis = item.split(':')[1];
              if(that.questionIndex==0){
                that.step = index+101;
              }else if(that.questionIndex==3){
                that.step = index+304;
                that.currentShortConversationIndex = 0;
              }else if(that.questionIndex==4){
                that.step = 407;
              }
            }
          });
          if(this.questionIndex == 4&&this.optionSelectedIndex==1){
            /*this.calculationMatrix.pop();*/
            this.meSelected = false;
          }else if(this.questionIndex == 4&&this.optionSelectedIndex==0){
            /*this.calculationMatrix.pop();*/
            this.meSelected = true;
          }
          this.qCardShow = false;
          setTimeout(function (){
            $('#teacherPic').fadeIn(200);
            that.teacherShow = true;
            setTimeout(function(){
              that.clickable = true;
              that.cardOnSubmit1 = false;
            },  1200);
          }, 1000);
        }else if(this.questionIndex == 7){
          let tempQuestion = this.currentQuestion;
          this.qCardShow = false;
          this.analysis = tempQuestion.director_comment[0];
          this.step = 702;
          setTimeout(function () {
            $('#teacherPic').fadeIn(200);
            that.teacherShow = true;
            setTimeout(function(){
              that.clickable = true;
              that.cardOnSubmit1 = false;
            }, 1200);
          }, 1000);
        } else{
          setTimeout(function(){
            that.clickable = true;
            that.cardOnSubmit1 = false;
          }, 1000)
        }
        this.eventHistory.push({
          'role':'你的选择',
          'comment':this.currentQuestion.options[this.optionSelectedIndex],
          'type':4
        },{
          'role':'导师点评',
          'comment':this.analysis,
          'type':5
        });
    });
    });
  }

  onSortQuestionBtnClick($event){
    let that = this;
    // console.log("Sort Question Button Clicked");
    // if(!this.isActiveSortBtn){
    //     return;
    // }
    if(this.cardOnSubmit2){
      return;
    } else{
      console.log("submit");
      this.cardOnSubmit2 = true;
    }
    let temp = '';
    let tempQuestion = this.currentQuestion;
    tempQuestion.options.forEach(function (item,index) {
      temp+=that.getSortOptionIdByContent(item);
    });
    this.sortQuestionsAnswer = temp;
    this.apiService.ajax({
      'type':'post',
      'url':'/api/pnoQuestion/'+this.exerciseId,
      'data':{
        'pno_question_id':this.currentQuestion.id,
        'pno_answer':this.sortQuestionsAnswer
      }
    }).subscribe(result=>{
      this.apiService.ajax({
        'type':'post',
        'url':'/api/pnoStorePoint/'+this.exerciseId,
        'data':{
          'pno_store_point_id':25
        }
      }).subscribe(result=>{
      	this.oldQuestionIndex = this.questionIndex;
        this.oldOptionSelectedIndex = this.optionSelectedIndex;
        this.clickable = false;
        this.analysis = tempQuestion.director_comment[0];
        this.qCardShow = false;
        setTimeout(function(){
          $('#teacherPic').fadeIn(200);
          that.teacherShow = true;
          that.step = 104;
          setTimeout(function(){
            that.cardOnSubmit2 = false;
            that.clickable = true;
          }, 1200);
        }, 1000);
        this.eventHistory.push({
          'role':'你的答案',
          'comment':this.currentQuestion.options,
          'type':4
        },{
          'role':'导师点评',
          'comment':this.analysis,
          'type':5
        });
      });
    });
  }

  submitCalculation($event){
    $event.stopPropagation();
    let that = this;
    // console.log("Cal Question Button Clicked");
    if(!this.isActiveCalculationBtn){
        return;
    }
    if(this.cardOnSubmit3){
      return;
    }else{
      console.log("submit");
      this.cardOnSubmit3 = true;
    }

     let temp = {
         '高':{
             '主':{
                 'A': this.calculationMatrix[0].numberArray[0],
                 'B': this.calculationMatrix[0].numberArray[1],
                 'C': 0
             },'分':{
                 'A': this.calculationMatrix[0].numberArray[2],
                 'B': 0,
                 'C': this.calculationMatrix[0].numberArray[3]
             }
         },'方':{
             '主':{
                 'A': this.calculationMatrix[1].numberArray[0],
                 'B': this.calculationMatrix[1].numberArray[1],
                 'C': 0
             },'分':{
                 'A': this.calculationMatrix[1].numberArray[2],
                 'B': 0,
                 'C': this.calculationMatrix[1].numberArray[3]
             }
         },'秦':{
             '主':{
                 'A': this.calculationMatrix[2].numberArray[0],
                 'B': this.calculationMatrix[2].numberArray[1],
                 'C': 0
             },'分':{
                 'A': this.calculationMatrix[2].numberArray[2],
                 'B': 0,
                 'C': this.calculationMatrix[2].numberArray[3]
             }
         }
     }
     if(this.meSelected){
         temp['我']={
             '主':{
                 'A': this.calculationMatrix[3].numberArray[0],
                 'B': this.calculationMatrix[3].numberArray[1],
                 'C': 0
             },'分':{
                 'A': this.calculationMatrix[3].numberArray[2],
                 'B': 0,
                 'C': this.calculationMatrix[3].numberArray[3]
             }
         };
     }
      this.apiService.ajax({
          'type':'post',
          'url':'/api/pnoQuestion/'+this.exerciseId,
          'data':{
              'pno_question_id':17,
              'pno_answer':JSON.stringify(temp)
          }
      }).subscribe(result=>{
          this.apiService.ajax({
              'type':'post',
              'url':'/api/pnoStorePoint/'+this.exerciseId,
              'data':{
                  'pno_store_point_id':45
              }
          }).subscribe(result=>{
              $('#calculationWrap').fadeOut(200);
              let tempQuestion;
              this.oldQuestionIndex = this.questionIndex;
              this.oldOptionSelectedIndex = this.optionSelectedIndex;
              if(this.questionIndex==4){
                  this.questionIndex+=2;
              }else{
                  this.questionIndex++;
              }
              this.optionSelectedIndex = -1;
              tempQuestion = this.questions[this.questionIndex];
              this.currentQuestion = tempQuestion;
              this.instruction = tempQuestion.title[0];
              setTimeout(function () {
                  that.instructionShow = true;
                  $('#reviewBtn').fadeIn(200);
                  that.step = 601;
                  setTimeout(function(){
                    that.clickable = true;
                    that.cardOnSubmit3 = false;
                  }, 1000);
              }, 500);
              this.eventHistory.push({
                  'role':'情节',
                  'comment': that.instruction,
                  'type':2
              });
          });
      });
  }

  onOptionMouseDown(i, event){
    if(this.optionClick == true || this.optionOnClick == true){
      return false;
    }
    // console.log("Option Question Button Clicked");
    let _this = this,
      pressing = $(event.target).children('.pressing'),  // 选项背景进度div
      pressingOption = pressing.children('.pressingOption'), // 选项背景进度div中的文字
      pressingWidth = $(event.target).width(), // 选项宽度
      pressingHeight = $(event.target).height(), // 选项高度
      pressingOuterHeight = $(event.target).outerHeight(),  // 选项真实高度, 包括margin, padding
      pressingOffset = $(event.target).offset(); // 选项在屏幕的位置
    let tempQuestion = this.currentQuestion;
    // 按选项少于0.45s, 则不响应
    this.optionClick = false;
    this.optionOnClick = true;
    // 设置选项动画参数
    pressingOption.width(pressingWidth);
    pressingOption.height(pressingHeight);
    pressing.width(0);
    pressing.height(pressingOuterHeight),
    pressing.show();
    pressing.offset({top: pressingOffset.top, left: pressingOffset.left});
    // 选项背景动画
    pressing.animate({
      width: $(event.target)[0].clientWidth
    }, this.type ? 300 : 500, 'linear');
    // 按中选项到达0.45s, 响应出现动画,  跳入下一个页面
    this.optionClickTimeout = setTimeout(function(){
      // 长按响应
      _this.optionClick = true;
      pressing.animate({width: 0}, 1);
      pressing.hide();
      // 进入选中按钮动画
      $(event.target).addClass('optionLongPress');
      // 按键之后的动画
      $(event.target).find('.loading').fadeIn(200);
      // 隐藏文字
      // 其他按钮的消失时间, 设置比选中按钮timeout时间长500ms, 维持按钮相对位置
      // console.log(_this.currentQuestion.options[i]);
      // $(event.target).not("").text("");
      $('.optionItem2').not($(event.target)).fadeOut(2500);
      _this.optionSelectedIndex = i;
      let pointId;
      if(_this.questionIndex==2){
        pointId = 30;
      }else if(_this.questionIndex==6){
        pointId = 50;
      }
      _this.apiService.ajax({
        'type':'post',
        'url':'/api/pnoQuestion/'+_this.exerciseId,
        'data':{
          'pno_question_id': tempQuestion.id,
          'pno_answer':_this.characterArray[_this.optionSelectedIndex]
        }
      }).subscribe(result=>{
        _this.apiService.ajax({
          'type':'post',
          'url':'/api/pnoStorePoint/'+_this.exerciseId,
          'data':{
              'pno_store_point_id':pointId
          }
        }).subscribe(result=>{
        	_this.oldQuestionIndex = _this.questionIndex;
          _this.oldOptionSelectedIndex = _this.optionSelectedIndex;
          // 保持选中按钮动画2s, 跳转动画
          // 移出按钮动画
          setTimeout(function(){
            $('#optionsWrap2').fadeOut(10);
            setTimeout(function(){
              $(event.target).removeClass('optionLongPress');
              _this.analysis = tempQuestion.director_comment[0];
              _this.eventHistory.push({
                  'role':'你的答案',
                  'comment': tempQuestion.options[_this.optionSelectedIndex],
                  'type':4
              },{
                  'role':'导师点评',
                  'comment':_this.analysis,
                  'type':5
              });
              setTimeout(function () {
                _this.optionClick = false;
                $('#teacherPic').fadeIn(200);
                _this.teacherShow = true;
                if(_this.questionIndex==2){
                    _this.step = 206;
                }else if(_this.questionIndex==6){
                    _this.step = 604;
                }
                setTimeout(function(){
                  _this.clickable = true;
                }, 1200);
              }, 350);
            }, 200);
          }, 1800); // end of second setTimeout
        });
      });
    }, 500); // end of first setTimeout
  } //end of onOptionMouseDown

onOptionMouseUp(event){
  this.optionOnClick = true;
  setTimeout(()=>{
    this.optionOnClick = false;
  },300);
  // 如果已经触发按钮事件, 忽略放松按钮行为
  if (this.optionClick == true){
    return true;
  }
  let pressing = $(event.target).children('.pressing');
  // 调整宽度为0
  setTimeout(()=>{
    clearTimeout(this.optionClickTimeout);
    pressing.stop().animate({
      width: 0
    }, 300, 'linear');
  },this.type ? 300 : 0);
}

  onOptionClick2($event,i){
    $event.stopPropagation();
      let that = this;
      if(!this.clickable){
          return;
      }
      this.clickable = false;
      this.optionSelectedIndex = i;
      let pointId;
      if(this.questionIndex==2){
          pointId = 30;
      }else if(this.questionIndex==6){
          pointId = 50;
      }

      this.apiService.ajax({
          'type':'post',
          'url':'/api/pnoQuestion/'+this.exerciseId,
          'data':{
              'pno_question_id':this.currentQuestion.id,
              'pno_answer':this.characterArray[this.optionSelectedIndex]
          }
      }).subscribe(result=>{
          this.apiService.ajax({
              'type':'post',
              'url':'/api/pnoStorePoint/'+this.exerciseId,
              'data':{
                  'pno_store_point_id':pointId
              }
          }).subscribe(result=>{
              $('#optionsWrap2').fadeOut(200);
              this.analysis = this.currentQuestion.director_comment[0];
              setTimeout(function () {


                  that.teacherShow = true;
                  if(that.questionIndex==2){
                      that.step = 206;
                  }else if(that.questionIndex==6){
                      that.step = 604;
                  }
                  setTimeout(function(){
                    that.clickable = true;
                  }, 1200);
              },350);
              this.eventHistory.push({
                  'role':'你的答案',
                  'comment':this.currentQuestion.options[this.optionSelectedIndex],
                  'type':4
              },{
                  'role':'导师点评',
                  'comment':this.analysis,
                  'type':5
              });
          });
      });
  }

  clickDialogEnable:boolean = true;
  reviewConversation($event){
      $event.stopPropagation();
      this.clickDialogEnable = false;
      $('#shade').fadeIn(50);
      $('#reviewBox').fadeIn();
      $('#closeBtn').fadeIn();
  }

  reviewTableClick($event,i){
    $event.stopPropagation();
    this.eventHistory[i].mode = (this.eventHistory[i].mode+1)%2;
  }

  closeTip($event){
      $event.stopPropagation();
      $('#shade').fadeOut();
      $('#reviewBox').fadeOut();
     /* $('#taskBookBox').fadeOut();*/
      $('#closeBtn').fadeOut();
      // 恢复点击功能
      this.clickDialogEnable = true;
  }

  onCustomerInfoBtn($event){
    $event.stopPropagation();
    $('#shade').fadeIn(200);
    $('#customerInfoWrap').fadeIn(200);
    $('#customerInfoCloseBtn').fadeIn(200);
  }

  onCustomerInfoCloseBtnClick($event){
      $event.stopPropagation();
      $('#shade').fadeOut(200);
      $('#customerInfoWrap').fadeOut(200);
      $('#customerInfoCloseBtn').fadeOut(200);
  }

  onSquareClick($event,i,j){
    $event.stopPropagation();
    let _this = this;
    if(this.customerArray[j]<=0){
        return;
    }
    /*if((i==0||i==1)&&(j==0||j==2)){
        return;
    }
    if(i==0&&j==1){
        return;
    }*/
    let currentTime = 0;
    this.calculationMatrix[i].numberArray.forEach(function (item,index) {
        currentTime+=item*_this.timeArray[index];
    });
    if(currentTime+this.timeArray[j]>240){
        return;
    }
      this.calculationMatrix[i].numberArray[j]++;
      this.customerArray[j]--;
      this.setCalculationSubmitBtnStatus();
  }

  onMinusBtnClick($event,i,j){
      $event.stopPropagation();
      if(this.calculationMatrix[i].numberArray[j]<=0){
          return;
      }
      this.calculationMatrix[i].numberArray[j]--;
      this.customerArray[j]++;
      this.setCalculationSubmitBtnStatus();
  }

  setCalculationSubmitBtnStatus(){
    let temp = false;
    let _this = this;
    this.calculationMatrix.forEach(function (item,index) {
        item.numberArray.forEach(function (subItem,index) {
            if(subItem>0){
                temp = true;
            }
        });
    });
      this.isActiveCalculationBtn = temp;
  }

  linkToReport(){
    const exerciseMetaId=$('#exerciseMetaId').val()
    console.log(localStorage.getItem('learningPathMetaId'))
    this.apiService.learingTime({learningPathMetaId:localStorage.getItem('learningPathMetaId'),module:"情景模拟",courseUnit:'',type:2,btnName:exerciseMetaId,userId:localStorage.getItem("userId")}).subscribe(result=>{
      console.log(result)
    })
    console.log(exerciseMetaId)
    this.commonService.sendPostMessage(2,'isPractice' +'Complete')
    let type = null
    this.route.queryParams.subscribe(queryParams=>{
        type=queryParams['type']
    })
    // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':localStorage.getItem('learningPathMetaId'),'module':'退出情景模拟1'}).then();
      this.apiService.ajax({
          'type':'post',
          'url':'/api/pnoCalKaPoint/'+this.exerciseId
      }).subscribe(result=>{
          this.apiService.finishExercise("" + this.exerciseId + "").subscribe(practice => {
            this.apiService.getKasInfos(this.exerciseId,this.practiceId).subscribe((result)=>{
              console.log(111111,result)
              if(result){
                this.apiService.getLevelInfo(result.reports[0]);
              }
            })
              let link=['case-practice-report-new',this.practiceId,this.exerciseId,this.learningPathId];
              if(type){
                this.router.navigate(link,{queryParams:{type:'huatek'}});
              }else{
                  this.router.navigate(link);
              }
          });
      });
  }

  setHeight(){
     let that = this;
      $(document).ready(function(){
        let temp = $(window).height() - 4*that.commonService.rootFontSize();
         $('#calculationTopPic').height(temp);
      });
  }

	showQFDialog(){
		$('#dialogueBox4').fadeIn(200);
		$('#qf2').fadeIn(200);
	}

	hideQFDialog(){
		$('#dialogueBox4').fadeOut(200);
		$("#qf2").fadeOut(200);
	}

  hideTip2(){
    $("#shade2").fadeOut();
    $('#tip2').fadeOut();
  }

  try(){
    $('body').css("height", "100%");
    let link = ['form', '3'];
    this.router.navigate(link);
    // if(this.userType === '3'){
    //   window.sessionStorage.setItem('submitType','1');
    //
    // }else{
    //   let link = ['success'];
    //   this.router.navigate(link);
    // }
  }

  returnList(){
    // let link = window.location.href+'#caseId='+Math.random();
    // console.log(link);
    // window.location.href =link;
    location.reload();
  }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-p-and-o-event/case-practice-p-and-o-event.component.ts